module.exports = __webpack_public_path__ + "assets/img/05.instance-log.acef0207.png";